/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import GenericTable from "../../components/GenericTable";
import GenericModal from "../../components/GenericModal";
import { Button, Form, Input, Row } from "antd";
import moment from "moment";
import TableLineIcons from "../../components/TableLineIcons";
import { Col } from "antd/es/grid";
import TableIDs from "../../data/TableIDs";


class AIKnowledge extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            modalReadOnly: false
        };

        this.id = "AI_KNOWLEDGE";

        this.api = {
            get: "get_ai_knowledge",
            create: "create_ai_knowledge",
            edit: "edit_ai_knowledge",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(20861);
    }

    handleCancel = () => {
        if (this.props.data[this.id].editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id);
        else this.props.dataActions.genericDataCancelEditing(this.id);
        this.setState({ modalReadOnly: false })
    }

    handleOk = () => {
        const { editing } = this.props.data[this.id]
        this.props.dataActions.genericDataSaveEdit(
            this.id, this.props.user.companyCode, this.props.user.token,
            editing == 0 ? this.api.create : this.api.edit,
            this.api.get);
    }

    handleEdit = (statusId) => {
        this.props.dataActions.genericDataSetEdit(this.id, { kStatus: statusId })
        setTimeout(this.handleOk, 500);
    }

    getStatusText = (id) => {
        switch (id) {
            case '1': return this.getText(20874)
            case '2': return this.getText(20875)
            case '3': return this.getText(20876)
            default: return this.getText(20877)
        }
    }

    renderEditCol = (text, record) => {
        const onEdit = () => { this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index) }
        const genericIcons = [{
            type: "eye",
            onClick: () => { this.setState({ modalReadOnly: true }, onEdit) },
            tooltip: this.getText(20878)
        }]

        return record.kStatus == '2' || record.kStatus == '3' ? (<TableLineIcons {...{ genericIcons }} />) : (<TableLineIcons {...{ onEdit, genericIcons }} />)
    }

    render() {
        const gt = this.getText;
        const render = t => t
        const renderUserInput = (t, r) => (<>{t}<br />{r.kInputDateTime ? moment(r.kInputDateTime).format("DD/MM/YYYY HH:mm") : ""}</>)
        const renderUserCheck = (t, r) => (<>{t}<br />{r.kCheckDateTime ? moment(r.kCheckDateTime).format("DD/MM/YYYY HH:mm") : ""}</>)
        const sorter = true;
        const { editing, editedRecord } = this.props.data[this.id]
        const setEdit = (f, e) => { this.props.dataActions.genericDataSetEdit(this.id, { [f]: e.target.value }) }

        const descField = (<Form.Item label={gt(20872)}><Input value={editedRecord.kDesc} onChange={e => { setEdit('kDesc', e) }} readOnly={this.state.modalReadOnly} /></Form.Item>)
        const dataField = (<Form.Item label={gt(20873)}><Input.TextArea value={editedRecord.kDATA} onChange={e => { setEdit('kDATA', e) }} rows={5} readOnly={this.state.modalReadOnly} /></Form.Item>)
        const modalEditTitle = (<span>
            {gt(20879)}: {editedRecord?.kID}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {gt(20880)}: {editedRecord?.kInputUserName} {editedRecord.kInputDateTime ? moment(editedRecord.kInputDateTime).format("DD/MM/YYYY HH:mm") : ""}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {gt(20881)}: {editedRecord?.kCheckUserName} {editedRecord.kCheckDateTime ? moment(editedRecord.kCheckDateTime).format("DD/MM/YYYY HH:mm") : ""}
        </span>)

        let isUserEditStatus2or3 = this.props.data[TableIDs.pseudoSelectorUIcomponentsModules].dataset?.find(f => f.code === '535')

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: "ltr"
            padding: "2% 2% 2% 2%",
        };

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                rowsFilter={r => r.key > 0}
                id={this.id}
                getApi={this.api.get}
                title={gt(20862)}
                addButton={() => { this.props.dataActions.genericDataStartInlineCreate(this.id) }}
                columns={[
                    { title: gt(20863), key: "kID", dataIndex: "kID", width: "10%", render, sorter },
                    { title: gt(20864), key: "kDesc", dataIndex: "kDesc", width: "35%", render, sorter },
                    { title: gt(20865), key: "kInputUserName", dataIndex: "kInputUserName", width: "20%", render: renderUserInput, sorter },
                    { title: gt(20866), key: "kCheckUserName", dataIndex: "kCheckUserName", width: "20%", render: renderUserCheck, sorter },
                    { title: gt(20867), key: "kStatus", dataIndex: "kStatus", width: "10%", render: this.getStatusText, sorter },
                    { title: gt(20868), width: "5%", render: this.renderEditCol },
                ]}
            />
            <GenericModal
                visible={editing == 0}
                onCancel={this.handleCancel}
                title={gt(20869)}
                width={600}
                footer={[
                    <Button key={"back"} onClick={this.handleCancel} style={{ margin: 5 }}>{gt(20871)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleOk} style={{ margin: 5 }}>{gt(20870)}</Button>,
                ]}>
                {descField}
                {dataField}
            </GenericModal>

            <GenericModal
                visible={editing > 0}
                onCancel={this.handleCancel}
                title={modalEditTitle}
                width={800}
                footer={this.state.modalReadOnly ? [
                    <Button key={"back"} onClick={this.handleCancel} style={{ margin: 5 }}>{gt(20882)}</Button>,
                ] : isUserEditStatus2or3 ? [
                    <Button key={"create1"} type={"primary"} onClick={() => { this.handleEdit('1') }} style={{ margin: 5 }}>{gt(20883)}</Button>,
                    <Button key={"create2"} type={"primary"} onClick={() => { this.handleEdit('2') }} style={{ margin: 5 }}>{gt(20884)}</Button>,
                    <Button key={"create3"} type={"primary"} onClick={() => { this.handleEdit('3') }} style={{ margin: 5 }}>{gt(20885)}</Button>,
                ] : [
                    <Button key={"create1"} type={"primary"} onClick={() => { this.handleEdit('1') }} style={{ margin: 5 }}>{gt(20883)}</Button>,
                ]}>
                <Row>
                    <Col span={16}>{descField}</Col>
                    <Col span={8} style={{ textAlign: "center" }}>{gt(20886)}: {this.getStatusText(editedRecord?.kStatus)}</Col>
                </Row>
                {dataField}
            </GenericModal>
        </div>)
    }

}

export default AIKnowledge;